import { Box, Divider, Typography } from '@mui/material';

const dividerStyles = ({ palette }) => ({
  '&::before, &::after': {
    borderWidth: 2,
    borderColor: palette.colors.lightGrey,
  },
});

const AuthDivider = () => (
  <Box>
    <Divider sx={dividerStyles}>
      <Typography variant="body1">Or</Typography>
    </Divider>
  </Box>
);

export default AuthDivider;
